export default "__VITE_ASSET__oDRf$zM7__"